import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { LoadingButton } from "@mui/lab";
import axiosInstance from "../../Api/axios.instance";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const MENU_ITEMS = [
  {
    title: "Clusters",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/clusters",
    icon: "GpsFixedIcon",
  },
  {
    title: "Subjects & Classes",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/class-subjects",
    icon: "SubjectIcon",
  },
  {
    title: "Staff",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/staff",
    icon: "PersonOutlineIcon",
  },
  {
    title: "Students",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/students",
    icon: "PeopleIcon",
  },
  {
    title: "Rollback",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/Rollback",
    icon: "PeopleIcon",
  },
  {
    title: "Parent Interview",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/parent-interview",
    icon: "PodcastsIcon",
  },
  {
    title: "Fee Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/fee-management",
    icon: "CreditCardIcon",
  },
  {
    title: "Student Attendance",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/attendance",
    icon: "HowToRegIcon",
  },
  {
    title: "Staff Attendance",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/staff-attendance",
    icon: "HowToRegIcon",
  },
  {
    title: "User Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/user-management",
    icon: "ManageAccountsIcon",
  },
  {
    title: "Test Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/test-management",
    icon: "NoteAltIcon",
  },
  {
    title: "Co-Curricular",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/co-curricular",
    icon: "AdminPanelSettingsIcon",
  },
  {
    title: "CAP",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/CAP",
    icon: "EventIcon",
  },
  {
    title: "PTM",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/PTM",
    icon: "MeetingRoomIcon",
  },
  {
    title: "Syllabus Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/syllabus",
    icon: "AssignmentIcon",
  },
  {
    title: "School Observation",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/fixed-assets/fixed-asset-observation",
    icon: "HomeRepairServiceIcon",
  },
  {
    title: "Variable Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/variable-management",
    icon: "CategoryIcon",
  },
  {
    title: "Library Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/library",
    icon: "LocalLibraryIcon",
  },
  {
    title: "Task Management",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/task",
    icon: "LocalTaskIcon",
  },
  {
    title: "Workshop",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/workshop",
    icon: "HomeRepairServiceIcon",
  },
  {
    title: "Class Observation",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/class-observation",
    icon: "ContentPasteSearchIcon",
  },
  {
    title: "School Record",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/school-record",
    icon: "AssignmentTurnedInIcon",
  },
  {
    title: "School Assembly",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/school-assembly",
    icon: "CastForEducationIcon",
  },
  {
    title: "Weekly Assembly Record",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/weekly-assembly-record",
    icon: "DvrIcon",
  },
  {
    title: "Fixed Assets",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/fixed-assets",
    icon: "ListAltIcon",
  },
  {
    title: "School Visit",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/school-visit",
    icon: "SchoolIcon",
  },
  {
    title: "Selected Teacher Training",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/selected-teacher-training",
    icon: "HomeRepairServiceIcon",
  },
];

const REPORT_ITEMS = [
  {
    title: "Fee Collection V1",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/fee-collection-v1",
    icon: "ReportIcon",
  },
  {
    title: "Daily Entries Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/daily-entries",
    icon: "ReportIcon",
  },
  {
    title: "Class Wise Students",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/class-wise-students",
    icon: "ReportIcon",
  },
  {
    title: "Student Profile",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/student-profile",
    icon: "ReportIcon",
  },
  {
    title: "Dropouts",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/dropout-students",
    icon: "ReportIcon",
  },
  {
    title: "Dropouts Session Wise",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/dropouts-session-wise",
    icon: "ReportIcon",
  },
  {
    title: "Orphans",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/orphans-strength",
    icon: "ReportIcon",
  },
  {
    title: "Male/Female Ratio",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/male-female-ratio",
    icon: "ReportIcon",
  },
  {
    title: "New Admissions School Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/new-admissions-school-wise",
    icon: "ReportIcon",
  },
  {
    title: "New Admissions Cluster Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/new-admissions-cluster-wise",
    icon: "ReportIcon",
  },
  {
    title: "Dropouts Summary",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/dropouts-summary",
    icon: "ReportIcon",
  },
  {
    title: "Dropouts School Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/dropout-student-school-wise",
    icon: "ReportIcon",
  },
  {
    title: "Passouts School Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/passout-student-school-wise",
    icon: "ReportIcon",
  },
  {
    title: "Subject/Variation Result Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/student-test-results-report",
    icon: "ReportIcon",
  },
  {
    title: "All Subject Result Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/student-all-subject-test-results-report",
    icon: "ReportIcon",
  },
  {
    title: "Grade Wise Cluster Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/student-by-grade-cluster-wise-report",
    icon: "ReportIcon",
  },
  {
    title: "Cluster Coordinator Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/cluster-coordinator-report",
    icon: "ReportIcon",
  },
  {
    title: "Exam Detail Cluster/School Wise Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/student-by-grade-school-class-wise-report",
    icon: "ReportIcon",
  },
  {
    title: "Teacher Attendance Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/teacher-attendance-summary",
    icon: "ReportIcon",
  },
  {
    title: "Test Result Attendance",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/testresult-present-absent-count-schoolwise",
    icon: "ReportIcon",
  },
  {
    title: "Active Student Details",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/active-student-report-school-wise",
    icon: "ReportIcon",
  },
  {
    title: "Active Student Attendance Stats",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/student-attendance-stats-date-range-school-wise",
    icon: "ReportIcon",
  },
  {
    title: "Class Observation Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/class-observation-report",
    icon: "ReportIcon",
  },
  {
    title: "Class Observation Gradewise Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/class-observation-report-gradewise",
    icon: "ReportIcon",
  },
  {
    title: "Class Observation Summary",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/class-observation-summary",
    icon: "ReportIcon",
  },
  {
    title: "List of Pending Class Teacher Observation",
    create: false,
    read: false,
    update: false,
    delete: false,
    route:
      "/reports/list-of-observation-not-done-class-teacher-observation-list-periodic",
    icon: "ReportIcon",
  },
  {
    title: "Class Teacher Observation Matrix",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/pivot-result-teacher-class-observation-period",
    icon: "ReportIcon",
  },
  {
    title: "Quit School Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/quit-student-school-wise",
    icon: "ReportIcon",
  },
  {
    title: "Asset Physical Condition",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/fixed-assets-condition",
    icon: "ReportIcon",
  },
  {
    title: "Paid Fee Summary School Wise",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/school-wise-fee-collection-report",
    icon: "ReportIcon",
  },
  {
    title: "Unpaid Fee List of Students",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/upaid-fee-school-wise-report",
    icon: "ReportIcon",
  },
  {
    title: "Attendance Monthly",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/attendance-monthly",
    icon: "ReportIcon",
  },
  {
    title: "Attendance Monthly Class Wise",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/attendance-monthly-class-wise",
    icon: "ReportIcon",
  },
  {
    title: "Attendance Weekly",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/attendance-weekly",
    icon: "ReportIcon",
  },
  {
    title: "School Visit Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/school-visit-report",
    icon: "ReportIcon",
  },
  {
    title: "School Assembly Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/school-assembly-report",
    icon: "ReportIcon",
  },
  {
    title: "Task Management Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/task-management-report",
    icon: "ReportIcon",
  },
  {
    title: "Promotion Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/promotion-report",
    icon: "ReportIcon",
  },
  {
    title: "All Tasks",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/all-task",
    icon: "ReportIcon",
  },
  {
    title: "Library Report",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/library-report",
    icon: "ReportIcon",
  },
  {
    title: "Activity Log",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/activity-log",
    icon: "ReportIcon",
  },
  {
    title: "CoCurricular Attendance",
    create: false,
    read: false,
    update: false,
    delete: false,
    route: "/reports/cocurricular-attendance",
    icon: "ReportIcon",
  },
  {
    "QIP Reports": [
      {
        title: "QIP School Observation Summary",
        create: false,
        read: false,
        update: false,
        delete: false,
        route: "/reports/qip-school-observation-summary",
        icon: "ReportIcon",
      },
      {
        title: "QIP School Observation",
        create: false,
        read: false,
        update: false,
        delete: false,
        route: "/reports/qip-school-observation",
        icon: "ReportIcon",
      },
      {
        title: "QIP School Observation Classes",
        create: false,
        read: false,
        update: false,
        delete: false,
        route: "/reports/qip-school-observation-classes",
        icon: "ReportIcon",
      },
      {
        title: "QIP School Observation Category",
        create: false,
        read: false,
        update: false,
        delete: false,
        route: "/reports/qip-school-observation-category",
        icon: "ReportIcon",
      },
      {
        title: "QIP All Region Summary",
        create: false,
        read: false,
        update: false,
        delete: false,
        route: "/reports/qip-all-region-summary",
        icon: "ReportIcon",
      },
      {
        title: "QIP SO Action Areas",
        create: false,
        read: false,
        update: false,
        delete: false,
        route: "/reports/school-observation-action-areas",
        icon: "ReportIcon",
      },
    ],
  },
];

export default function AddUserRoles() {
  const getInitialMenus = () => JSON.parse(JSON.stringify(MENU_ITEMS));
  const getInitialReports = () => JSON.parse(JSON.stringify(REPORT_ITEMS));
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackBar] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [menus, setMenus] = useState(() => getInitialMenus());
  const [reports, setReports] = useState(() => getInitialReports());
  const [roleName, setRoleName] = useState("");
  const [accesLevel, setAccesLevel] = useState("");
  const [dashboards, setDashboards] = useState({
    ADMIN: false,
    CLUSTER: false,
    COMPLIANCE: false,
    SCHOOL: false,
  });

  const _resetForm = () => {
    console.log("Menus after submission", menus);
    console.log("Reports after submission", reports); 
    setRoleName("");
    setAccesLevel("");
    setDashboards({
      ADMIN: false,
      CLUSTER: false,
      COMPLIANCE: false,
      SCHOOL: false,
    });
    setMenus(getInitialMenus());
    setReports(getInitialReports());
  };

  const handleMenusChange = (e, key) => {
    const { name, value } = e?.target;
    const newMenus = [...menus];
    newMenus[key][name] = e.target.checked;
    setMenus(newMenus);
  };

  const handleReportsChange = (e, key) => {
    const { name, value } = e?.target;
    const newReports = [...reports];
    newReports[key][name] = e.target.checked;
    setReports(newReports);
  };

  const handleRoleNameChange = (e) => {
    setRoleName(e.target.value);
  };

  const handleAccessLevelChange = (e) => {
    setAccesLevel(e.target.value);
  };

  const handleDashboardChange = (e) => {
    const { name, checked } = e.target;
    setDashboards((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleQipReportsChange = (e, parentIndex, childIndex) => {
    const { name, checked } = e.target;

    setReports((prevReports) =>
      prevReports.map((item, pIndex) => {
        if (pIndex !== parentIndex) return item;

        return {
          ...item,
          "QIP Reports": item["QIP Reports"].map((qipItem, cIndex) => {
            if (cIndex !== childIndex) return qipItem;

            return {
              ...qipItem,
              [name]: checked,
            };
          }),
        };
      }),
    );
  };
  const snack_handleClose = () => {
    console.log("Snack bar Closed");
    setSnackBar(false);
  };

  const _onSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const formattedReports = reports.map((item) => {
        if (item["QIP Reports"]) {
          return {
            "QIP Reports": item["QIP Reports"],
          };
        }
        return item;
      });

      const formData = {
        roleName,
        status: true,
        permission: {
          accessLevel: accesLevel,
          pages: [
            ...menus,
            {
              Reports: formattedReports,
            },
          ],
        },
      };

      const { data, status } = await axiosInstance.post("/roles", formData);

      const SchoolID = JSON.parse(localStorage.getItem("UserAccess"))[0]
        .SchoolId;
      const UserId = JSON.parse(localStorage.User).username;

      const logParams = {
        user_id: UserId,
        school_id: SchoolID,
        module: "User Management -Add User Role",
        data: JSON.stringify(formData),
        DML_type: "Create",
      };

      await axiosInstance.post(
        "/activity_trails/create_activity_trail",
        logParams,
      );

      if (status === 200) {
        setSnackMessage(data.message);
        setSnackBar(true);
        _resetForm();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("mmmmmm : ", menus);
    console.log("mmmmmm : ", reports); 
  }, []);

  return (
    <>
      <Box flexGrow={1} onSubmit={_onSubmit} component="form">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Typography variant="h5" component="h4">
              Roles
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Divider sx={{ mt: 1, mb: 2 }} />
          </Grid>
          <Grid item xs={12} md={6} sx={{ mb: 2 }}>
            <TextField
              label="Role Name"
              variant="outlined"
              size="small"
              sx={{ display: "flex", flex: 1 }}
              name="roleName"
              value={roleName}
              // value={element.IndexID}
              onChange={handleRoleNameChange}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="standard-select-currency"
              select
              label="Select Access Level"
              sx={{ display: "flex", flex: 1 }}
              // value={formik.values.SchoolID}
              variant="outlined"
              name="accesLevel"
              value={accesLevel}
              required
              onChange={handleAccessLevelChange}
              // error={formik.touched.SchoolID && Boolean(formik.errors.SchoolID)}
              // helperText={formik.touched.SchoolID && formik.errors.SchoolID}
              size="small"
            >
              <MenuItem value={"ADMIN"}>ADMIN</MenuItem>
              <MenuItem value={"CLUSTER"}>CLUSTER</MenuItem>
              <MenuItem value={"SCHOOL"}>SCHOOL</MenuItem>
              <MenuItem value={"STAFF"}>STAFF</MenuItem>
              {/* <MenuItem value={"TEACHER"}>TEACHER</MenuItem> */}
            </TextField>
          </Grid>
        </Grid>
        {/* ------------ Dashboards in User Roles----------- */}
        {/* <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Typography variant="h6" component="h4">
              Dashboards
            </Typography>
          </Grid>
          {["ADMIN", "CLUSTER", "COMPLIANCE", "SCHOOL"].map((type) => (
            <Grid item xs={12} md={3} key={type}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dashboards[type]}
                    name={type}
                    onChange={handleDashboardChange}
                  />
                }
                label={type}
              />
            </Grid>
          ))}

          <Grid xs={12} md={12}>
            <Divider sx={{ mt: 2, mb: 2 }} />
          </Grid>
        </Grid> */}

        {menus
          .filter((item, index) => index < 27)
          .map((menu, index) => {
            return (
              <Grid container spacing={2} key={index}>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography variant="h6" component="h4">
                        {menu.title}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.create}
                        name="create"
                        control={<Checkbox checked={menu.create} />}
                        label="CREATE"
                        labelPlacement="CREATE"
                        onChange={(e) => handleMenusChange(e, index)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.read}
                        name="read"
                        control={<Checkbox checked={menu.read} />}
                        label="READ"
                        labelPlacement="READ"
                        onChange={(e) => handleMenusChange(e, index)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.update}
                        name="update"
                        control={<Checkbox checked={menu.update} />}
                        label="UPDATE"
                        labelPlacement="UPDATE"
                        onChange={(e) => handleMenusChange(e, index)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.delete}
                        name="delete"
                        control={<Checkbox checked={menu.delete} />}
                        label="DELETE"
                        labelPlacement="DELETE"
                        onChange={(e) => handleMenusChange(e, index)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                </Grid>
              </Grid>
            );
          })}
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Divider sx={{ mt: 1, mb: 2 }} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography variant="h5" component="h4">
              Reports
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Divider sx={{ mt: 1, mb: 2 }} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Divider sx={{ mt: 1, mb: 2 }} />
          </Grid>
        </Grid>
        {/* {reports
          .filter((item, index) => index < 35)
          .map((menu, index) => {
            return (
              <Grid container spacing={2} key={index}>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography variant="h6" component="h4">
                        {menu.title}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.create}
                        name="create"
                        control={<Checkbox checked={menu.create} />}
                        label="CREATE"
                        labelPlacement="CREATE"
                        onChange={(e) => handleReportsChange(e, index)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.read}
                        name="read"
                        control={<Checkbox checked={menu.read} />}
                        label="READ"
                        labelPlacement="READ"
                        onChange={(e) => handleReportsChange(e, index)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.update}
                        name="update"
                        control={<Checkbox checked={menu.update} />}
                        label="UPDATE"
                        labelPlacement="UPDATE"
                        onChange={(e) => handleReportsChange(e, index)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControlLabel
                        value={menu.delete}
                        name="delete"
                        control={<Checkbox checked={menu.delete} />}
                        label="DELETE"
                        labelPlacement="DELETE"
                        onChange={(e) => handleReportsChange(e, index)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                </Grid>
              </Grid>
            );
          })} */}
        {reports.map((menu, index) => {
          // Normal Reports
          if (menu.title) {
            return (
              <Grid container spacing={2} key={index}>
                <Grid item xs={12}>
                  <Typography variant="h6" component="h4">
                    {menu.title}
                  </Typography>
                </Grid>

                {["create", "read", "update", "delete"].map((type) => (
                  <Grid item xs={12} md={3} key={type}>
                    <FormControlLabel
                      name={type}
                      control={<Checkbox checked={menu[type]} />}
                      label={type.toUpperCase()}
                      onChange={(e) => handleReportsChange(e, index)}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} md={12}>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                </Grid>
              </Grid>
            );
          }

          // QIP Reports Section
          if (menu["QIP Reports"]) {
            return (
              <Grid container spacing={1} key={index}>
                <Grid item xs={12} md={12}>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography variant="h5" component="h4">
                    QIP Reports
                  </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                </Grid>

                {menu["QIP Reports"].map((qipItem, qipIndex) => (
                  <Grid container spacing={2} key={qipIndex}>
                    <Grid item xs={12}>
                      <Typography variant="h6" component="h4">
                        {qipItem.title}
                      </Typography>
                    </Grid>

                    {["create", "read", "update", "delete"].map((type) => (
                      <Grid item xs={12} md={3} key={type}>
                        <FormControlLabel
                          name={type}
                          control={<Checkbox checked={qipItem[type]} />}
                          label={type.toUpperCase()}
                          onChange={(e) =>
                            handleQipReportsChange(e, index, qipIndex)
                          }
                        />
                      </Grid>
                    ))}
                    <Grid item xs={12} md={12}>
                      <Divider sx={{ mt: 1, mb: 2 }} />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            );
          }

          return null;
        })}

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <FormControl fullWidth>
              <LoadingButton
                loading={loading}
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                Create Role
              </LoadingButton>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbar}
        autoHideDuration={6000}
        onClose={snack_handleClose}
      >
        <Alert
          onClose={snack_handleClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
